module.exports = __webpack_public_path__ + "img/cloud-sun-2.7cbda081.svg";